(function () {
    'use strict';
    
    angular.module('app').factory('file.service', ['$rootScope', '$q', 'toastr', 'log.factory', 'compress.service', function ($rootScope, $q, toastr, _log, _compress) {

        var extensions = [
            { fa: 'fa-file-word-o', types: ['docx', 'doc'] },
            { fa: 'fa-file-excel-o', types: ['xlsx', 'xls'] },
            { fa: 'fa-file-pdf-o', types: ['pdf'] },
            { fa: 'fa-file-image-o', types: ['png', 'jpg', 'jpeg', 'gif', 'bmp'] },
            { fa: 'fa-file-text-o', types: ['txt', 'csv'] }
        ];

        return {
            findIcon: function (extension) {
                // Find icon
                return _.find(extensions, function (ext) {
                    return _.indexOf(ext.types, extension.replace(".", "")) > -1;
                });
            },
            icon: function (extension) {

                // Find icon
                var icon = this.findIcon(extension);

                // Use icon, if not found use default
                if (!_.isUndefined(icon) && !_.isNull(icon)) {
                    return icon.fa;
                } else {
                    return 'fa-file-o';
                }
            },
            add: function () {

                var self = this;

                // Deferred
                var deferred = $q.defer();
                // Create input
                self.input = document.createElement('input');
                self.input.type = 'file';
                self.input.onchange = function () {
                    if (self.input.files.length > 0) {
                        // Upload file
                        var f = self.input.files[0], r = new FileReader();

                        // File
                        var file = { Handle: -1, Extension: extension(f.name.toLowerCase()), Data: null, Name: f.name };

                        // Icon
                        var icon = self.findIcon(file.Extension);

                        // Is file allowed
                        if (_.isUndefined(icon)) {
                            // Display error
                            toastr.warning('File not allowed');
                            // Add to log
                            _log.error("file", "file.add", "File '" + file.Name + "' not allowed.");
                            // Rject
                            deferred.reject('File not allowed');
                        }

                        r.onloadend = function (e) {                           

                            // If image compress
                            if (icon.fa == "fa-file-image-o") {
                                _compress.compress(URL.createObjectURL(f), "png").then(function (compressedDataUrl) {
                                    file.Data = compressedDataUrl;
                                    file.Name = file.Name.replace(file.Extension, ".png");
                                    file.Extension = ".png";
                                    deferred.resolve(file);
                                });
                            } else {
                                // Not an image, continue
                                // Set data
                                file.Data = e.target.result;                                  
                                deferred.resolve(file);
                            }
                        }
                        r.readAsDataURL(f);
                    }
                };
                self.input.click();
                return deferred.promise;
            }
        }
    }]);
})();